module.exports = __webpack_public_path__ + "static/media/2021 04 20  INFORMACJA O AGENCIE - zmiana kapitału.18d0890e.pdf";